<template>
  <nav
    class="fixed bottom-0 left-0 right-0 z-40 bg-surface/90 backdrop-blur-xl border-t border-line safe-bottom"
  >
    <div class="flex items-stretch justify-between max-w-screen-md mx-auto px-4 pt-3 pb-2 gap-2">
      <!-- Home -->
      <router-link
        to="/home/dashboard"
        class="nav-item"
        :class="{ 'nav-item--active': isActive('/home/dashboard') }"
      >
        <div class="nav-ic">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 11.5 12 4l9 7.5V20a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1v-8.5Z" />
          </svg>
        </div>
        <span class="nav-label">Home</span>
      </router-link>

      <!-- Collect (primary action — emphasized) -->
      <button
        type="button"
        @click="handleCollect"
        class="nav-item nav-item--primary"
        :class="{ 'nav-item--active-primary': isActive('/home/collect') }"
      >
        <div class="nav-ic-primary">
          <svg class="w-7 h-7" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <span class="nav-label font-bold">Collect</span>
      </button>

      <!-- Deliver -->
      <button
        type="button"
        @click="handleDeliver"
        class="nav-item"
        :class="{ 'nav-item--active': isActive('/home/deliver') }"
      >
        <div class="nav-ic">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 7.5 12 3l9 4.5M3 7.5v9L12 21m-9-13.5L12 12m0 9 9-4.5v-9M12 12v9m0-9 9-4.5" />
          </svg>
        </div>
        <span class="nav-label">Deliver</span>
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { useUIStore } from '@/stores/ui'
import { useCollectionStore } from '@/stores/collection'

const route = useRoute()
const router = useRouter()
const uiStore = useUIStore()
const collectionStore = useCollectionStore()

function isActive(path: string): boolean {
  return route.path === path || route.path.startsWith(path + '/')
}

function handleCollect() {
  if (!uiStore.selectedTruck) {
    uiStore.showToast('Please select a truck first', 'warning')
    router.push('/select-truck')
    return
  }
  collectionStore.clearCollection()
  router.push('/home/collect')
}

function handleDeliver() {
  if (!uiStore.selectedTruck) {
    uiStore.showToast('Please select a truck first', 'warning')
    router.push('/select-truck')
    return
  }
  router.push('/home/deliver')
}
</script>

<style scoped>
.nav-item {
  @apply flex-1 flex flex-col items-center justify-center gap-1
         py-2 rounded-2xl text-ink-muted
         transition-all duration-200
         active:scale-[0.96];
  min-height: 60px;
}
.nav-item--active {
  @apply text-ink;
}
.nav-ic {
  @apply flex items-center justify-center w-11 h-11 rounded-2xl
         transition-all duration-200;
}
.nav-item--active .nav-ic {
  @apply bg-canvas-2 text-ink;
}

.nav-item--primary {
  @apply text-ink;
}
.nav-ic-primary {
  @apply flex items-center justify-center w-14 h-14
         rounded-2xl bg-ink text-surface
         shadow-card-lg
         transition-all duration-200;
  margin-top: -22px;
}
.nav-item--primary:hover .nav-ic-primary {
  @apply scale-[1.03];
}
.nav-item--active-primary .nav-ic-primary {
  @apply bg-primary ring-4 ring-primary/15;
}

.nav-label {
  @apply text-[11px] font-semibold tracking-wide;
}
</style>
